/* eslint-disable camelcase */
import bridge from '@vkontakte/vk-bridge';
import { createEffect } from 'effector';
import { VK_MINI_APP_ID } from 'src/shared/config';

export const getUserAccessTokenFx = createEffect<string | null, string, Error>(
  async scope => {
    try {
      const { access_token } = await bridge.send('VKWebAppGetAuthToken', {
        app_id: VK_MINI_APP_ID,
        scope: scope ?? ''
      });

      if (access_token) {
        return access_token;
      }

      throw new Error('Произошла ошибка при получении токена');
    } catch (error) {
      throw new Error(String(error));
    }
  }
);
